export const ConditionalController = (experimentName, controllerWhenTrue, controllerWhenFalse) => controllerParams => {
  const {
    siteStore
  } = controllerParams.appData?.context ?? {};
  if (!siteStore?.experiments.enabled(experimentName)) {
    return controllerWhenFalse(controllerParams);
  }
  return controllerWhenTrue(controllerParams);
};
//# sourceMappingURL=ConditionalController.js.map